import { SearchDto } from '@/types/typeAhead';
import { BaseService } from './base.service';

export class TypeAheadService extends BaseService {
  constructor() {
    super('/type-ahead');
  }

  async getForCategory(category: string): Promise<string[]> {
    return this.get<string[]>(`/${category}`);
  }

  async searchInCategory(category: string, searchDto: SearchDto): Promise<string[]> {
    return this.post<string[]>(`/search/${category}`, searchDto);
  }

  async addToTypeAhead(category: string, value: string): Promise<any> {
    return this.put('', { category, values: [value] });
  }
}

export const typeAheadService = new TypeAheadService();
